var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 3h2v17H0zM11.257 15.036l.707.707 7.779-7.779-.707-.707z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.139 13h1V7h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.932 8V7h6v1zM0 2h14v2H0zM0 20h24v2H0z"
}))));
export default SvgExternalLink;